<template>
<!-- row = linha -->
<div class="row">
    <div class="row">
        <div class="col-3">
            <base-input class="text-left" label="Início do Horário Noturno">
                <el-input color="success" v-mask="'##:##'" placeholder="Insira um horário de início" v-model="payload.inicioHoraNoturna" :class="erros.inicioHoraNoturna === true ? 'has-danger' : ''">
                </el-input>
            </base-input>
        </div>

        <div class="col-3">
            <base-input class="text-left" label="Término do Horário Noturno">
                <el-input color="success" v-mask="'##:##'" placeholder="Insira um horário término" v-model="payload.fimHoraNoturna" :class="erros.fimHoraNoturna === true ? 'has-danger' : ''">
                </el-input>
            </base-input>
        </div>

        <div class="col-3">
            <base-input class="text-left" label="Fator Horas Noturnas">
                <el-input color="success" v-mask="'##:##'" placeholder="Insira uma hora" v-model="payload.fatorNoturno" :class="erros.fatorNoturno === true ? 'has-danger' : ''">
                </el-input>
            </base-input>
        </div>
    </div>
    <div class="row">
        <div class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios">
            <label class="texto-responsivo">Incluir intervalo:</label>
            <base-radio class="ml-3 mt-0 col-12" name="1" v-model="payload.intervaloNotuno">Sim</base-radio>
            <base-radio class="ml-3 mt-0 col-12" name="0" v-model="payload.intervaloNotuno">Não</base-radio>
        </div>

        <div class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios">
            <label class="texto-responsivo">Extender até o término da jornada do dia (batida final de
                saída):</label>
            <base-radio class="ml-3 mt-0 col-12" name="1" v-model="payload.extenderTerminoJornada">Sim</base-radio>
            <base-radio class="ml-3 mt-0 col-12" name="0" v-model="payload.extenderTerminoJornada">Não</base-radio>
        </div>
    </div>
    <div class="row">
        <div class="offset-10 col-2 mt-2">
            <base-button type="success" @click="salvar()" class="animation-on-hover">Salvar</base-button>
        </div>
    </div>
</div>
</template>

<script>
import {
    BaseInput
} from "../../components/index";
import {
    Select,
    Option
} from "element-ui";

export default {
    name: "FormAdicionalNoturno",
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        BaseInput,
    },
    props: {
        posto: "",
        parametros: "",
        isLoading: false
    },
    data() {
        return {
            payload: {
                setDB: "",
                inicioHoraNoturna: "",
                fimHoraNoturna: "",
                fatorNoturno: "",
                intervaloNotuno: "1",
                extenderTerminoJornada: "1"
            },
            erros: {
                inicioHoraNoturna: "",
                fimHoraNoturna: "",
                fatorNoturno: "",
            }
        }
    },
    mounted() {
        this.carregarAdicionalNoturno();

    },
    methods: {
        carregarAdicionalNoturno() {

            if (this.parametros) {
                this.payload.inicioHoraNoturna = this.parametros.inicioHoraNoturna.slice(0, -3);
                this.payload.fimHoraNoturna = this.parametros.fimHoraNoturna.slice(0, -3);
                this.payload.fatorNoturno = this.parametros.fatorNoturno.slice(0, -3);
                this.payload.intervaloNotuno = this.parametros.intervaloNotuno.toString();
                this.payload.extenderTerminoJornada = this.parametros.extenderTerminoJornada.toString();
            }
        },
        validarDados() {
            let status = true;
            if (!this.payload.inicioHoraNoturna || this.payload.inicioHoraNoturna === "") {
                status = false;
                this.erros.inicioHoraNoturna = true;
            } else this.erros.inicioHoraNoturna = false;

            if (!this.payload.fimHoraNoturna || this.payload.fimHoraNoturna === "") {
                status = false;
                this.erros.fimHoraNoturna = true;
            } else this.erros.fimHoraNoturna = false;

            if (!this.payload.fatorNoturno || this.payload.fatorNoturno === "") {
                status = false;
                this.erros.fatorNoturno = true;
            } else this.erros.fatorNoturno = false;

            return status;
        },
        salvar() {
            if (!this.validarDados()) return;

            this.payload.setDB = this.$cookies.get("db");
            this.$emit("salvarAdicional", this.payload);
        },
    },
    watch: {
        nome() {
            this.payload.razao_social = String(
                this.payload.razao_social
            ).toUpperCase();
        },
        email() {
            this.payload.email = String(this.payload.email).toLowerCase();
        },
    }

};
</script>

<style>
.texto-responsivo {
    font-size: clamp(1rem, 2.5vw, 2rem);
}
.el-input {
    margin-top: 5px;
    width: calc(100% - 20px);
}
</style>
